import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Close, Minus } from 'UI/Icons';
import { FlexibleTextArea } from 'UI/Inputs';

var CustomCoreContent = /*#__PURE__*/function (_Component) {
  _inherits(CustomCoreContent, _Component);

  var _super = _createSuper(CustomCoreContent);

  function CustomCoreContent(props) {
    var _this;

    _classCallCheck(this, CustomCoreContent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        var coreContents = _this.state.coreContents;
        /*
        let data = {
        	title: coreContents.title,
        	id: coreContents.id,
        	aspects: [],
        };
        	coreContents.aspects.map(aspect => {
        	if (aspect.title != '') {
        		let newAspect = {
        			title: aspect.title,
        			aspectRows: [],
        			id: aspect.id,
        		};
        			aspect.aspectRows.map(aspectRow => {
        			if (aspectRow.text != '') {
        				newAspect.aspectRows.push(aspectRow);
        			}
        		});
        			data.aspects.push(newAspect);
        			return aspect;
        	}
        });*/

        var dataArray = [];
        coreContents.map(function (coreContent) {
          var data = {
            title: coreContent.title,
            id: coreContent.id,
            aspects: []
          };
          coreContent.aspects.map(function (aspect) {
            if (aspect.title != '') {
              var newAspect = {
                title: aspect.title,
                aspectRows: [],
                id: aspect.id
              };
              aspect.aspectRows.map(function (aspectRow) {
                if (aspectRow.text != '') {
                  newAspect.aspectRows.push(aspectRow);
                }
              });
              data.aspects.push(newAspect);
              return aspect;
            }
          });
          dataArray.push(data);
        });

        _this.props.onChange(dataArray);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      if (_this.state.coreContents.length < 1) {
        _this.addCoreContent();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addCoreContent", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          coreContents = _this$state.coreContents,
          contentRowCount = _this$state.contentRowCount;
      var newObject = {
        key: 'core-content-' + _this.state.coreContents.length + ':' + contentRowCount,
        title: '',
        aspects: []
      };
      coreContents.push(newObject);
      contentRowCount++;

      _this.setState({
        coreContents: coreContents,
        contentRowCount: contentRowCount
      }, function () {
        _this.addAspect(newObject);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addAspect", function (contentRow) {
      var _this$state2 = _this.state,
          coreContents = _this$state2.coreContents,
          aspectCount = _this$state2.aspectCount;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var newAspect = {
        key: contentRow.key + '-aspect-' + stateObject.aspects.length + ':' + aspectCount,
        title: '',
        aspectRows: []
      };
      stateObject.aspects.push(newAspect);
      aspectCount++;

      _this.setState({
        coreContents: coreContents,
        aspectCount: aspectCount
      }, function () {
        _this.addAspectRow(newAspect, contentRow);

        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addAspectRow", function (aspect, contentRow) {
      var _this$state3 = _this.state,
          coreContents = _this$state3.coreContents,
          aspectRowCount = _this$state3.aspectRowCount;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var aspectObject = stateObject.aspects.find(function (as) {
        return as.key == aspect.key;
      });
      var newAspectRow = {
        key: aspect.key + '-aspectRow-' + aspect.aspectRows.length + ':' + aspectRowCount,
        text: ''
      };
      aspectObject.aspectRows.push(newAspectRow);
      aspectRowCount++;

      _this.setState({
        coreContents: coreContents,
        aspectRowCount: aspectRowCount
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAspectTitleChange", function (text, aspect, contentRow) {
      var coreContents = _this.state.coreContents;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var aspectObject = stateObject.aspects.find(function (as) {
        return as.key == aspect.key;
      });
      aspectObject.title = text;

      _this.setState({
        coreContents: coreContents
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAspectRowTextChange", function (text, aspectRow, aspect, contentRow) {
      var coreContents = _this.state.coreContents;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var aspectObject = stateObject.aspects.find(function (as) {
        return as.key == aspect.key;
      });
      var aspectRowObject = aspectObject.aspectRows.find(function (ar) {
        return ar.key == aspectRow.key;
      });
      aspectRowObject.text = text;

      _this.setState({
        coreContents: coreContents
      }, function () {
        var aspectRowIndex = aspectObject.aspectRows.findIndex(function (ar) {
          return ar.key == aspectRow.key;
        });

        if (aspectRowIndex + 1 == aspectObject.aspectRows.length) {
          if (aspectRowObject.text != '') {
            _this.addAspectRow(aspect, contentRow);
          }
        }

        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onContentRowDelete", function (contentRow) {
      var coreContents = _this.state.coreContents;
      var contentRowIndex = coreContents.findIndex(function (cc) {
        return cc.key == contentRow.key;
      });
      coreContents.splice(contentRowIndex, 1);

      _this.setState({
        coreContents: coreContents
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAspectDelete", function (aspect, contentRow) {
      var coreContents = _this.state.coreContents;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var aspectIndex = stateObject.aspects.findIndex(function (as) {
        return as.key == aspect.key;
      });
      stateObject.aspects.splice(aspectIndex, 1);

      _this.setState({
        coreContents: coreContents
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAspectRowDelete", function (aspectRow, aspect, contentRow) {
      var coreContents = _this.state.coreContents;
      var stateObject = coreContents.find(function (cc) {
        return cc.key == contentRow.key;
      });
      var aspectObject = stateObject.aspects.find(function (as) {
        return as.key == aspect.key;
      });
      var aspectRowIndex = aspectObject.aspectRows.findIndex(function (ar) {
        return ar.key == aspectRow.key;
      });
      aspectObject.aspectRows.splice(aspectRowIndex, 1);

      _this.setState({
        coreContents: coreContents
      }, function () {
        _this.onChange();
      });
    });

    var init = {
      coreContents: [],
      contentRowCount: 0,
      aspectCount: 0,
      aspectRowCount: 0
    };

    if (props.coreContents != null) {
      init.coreContents = props.coreContents;
      init.contentRowCount = props.coreContents.length;
      props.coreContents.forEach(function (coreContent) {
        coreContent.key = coreContent.id;

        if (coreContent.aspects != null && coreContent.aspects.length > 0) {
          init.aspectCount += coreContent.aspects.length;
          coreContent.aspects.map(function (aspect) {
            aspect.key = aspect.id;

            if (aspect.aspectRows != null && aspect.aspectRows.length > 0) {
              init.aspectRowCount = init.aspectRowCount + aspect.aspectRows.length;
              aspect.aspectRows.map(function (aspectRow) {
                aspectRow.key = aspectRow.id;
                return aspectRow;
              });
            }

            return aspect;
          });
        }
      });
    }

    _this.state = init;
    return _this;
  }

  _createClass(CustomCoreContent, [{
    key: "render",
    value:
    /*
    	<div onClick={ e => this.onContentRowDelete( contentRow ) } className="remove-button-container">
    		<div className="remove-icon-container"><Minus /></div>
    		Ta bort sektion
    	</div>
    */
    function render() {
      var _this2 = this;

      var coreContents = this.state.coreContents;
      return /*#__PURE__*/React.createElement("div", {
        className: "core-content"
      }, coreContents.map(function (contentRow) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-row custom-row",
          key: contentRow.key
        }, /*#__PURE__*/React.createElement("div", {
          className: "aspects"
        }, contentRow.aspects.map(function (aspect, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "aspect-row",
            key: aspect.key
          }, /*#__PURE__*/React.createElement("span", {
            className: "subtitle"
          }, _this2.props.translate('core-section'), " ", index + 1), /*#__PURE__*/React.createElement("div", {
            onClick: function onClick(event) {
              return _this2.onAspectDelete(aspect, contentRow);
            },
            className: "remove-button-container"
          }, /*#__PURE__*/React.createElement("div", {
            className: "remove-icon-container"
          }, /*#__PURE__*/React.createElement(Minus, null)), _this2.props.translate('remove-core-section')), /*#__PURE__*/React.createElement("input", {
            type: "text",
            value: aspect.title,
            onChange: function onChange(event) {
              var value = event.target.value;

              _this2.onAspectTitleChange(value, aspect, contentRow);
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: "aspects"
          }, /*#__PURE__*/React.createElement("span", {
            className: "subtitle",
            style: {
              marginTop: '1.25em'
            }
          }, _this2.props.translate('content')), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }), aspect.aspectRows.map(function (aspectRow) {
            return /*#__PURE__*/React.createElement("div", {
              className: "aspect-add",
              key: aspectRow.key
            }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
              value: aspectRow.text != null ? aspectRow.text : '',
              onChange: function onChange(event) {
                var value = event.target.value;

                _this2.onAspectRowTextChange(value, aspectRow, aspect, contentRow);
              }
            }), /*#__PURE__*/React.createElement("div", _defineProperty({
              onClick: function onClick(event) {
                event.preventDefault();

                _this2.onAspectRowDelete(aspectRow, aspect, contentRow);
              },
              className: "tooltip",
              "data-tooltip": _this2.props.translate('remove-content')
            }, "className", "aspects-remove"), /*#__PURE__*/React.createElement("div", {
              style: {
                width: '15px'
              }
            }, /*#__PURE__*/React.createElement(Close, null))));
          }), /*#__PURE__*/React.createElement("div", {
            className: "core-content-add-btn",
            style: {
              marginTop: '0.75em'
            },
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.addAspectRow(aspect, contentRow);
            }
          }, "+ ", _this2.props.translate('add-content'))));
        }), /*#__PURE__*/React.createElement("div", {
          className: "core-content-add-btn",
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.addAspect(contentRow);
          }
        }, "+ ", _this2.props.translate('add-core-section'))));
      }));
    }
  }]);

  return CustomCoreContent;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(CustomCoreContent);